<his-plam [label]="setting().label | hisUi"
          [helptext]="setting().helptext | hisUi" [required]="setting().required"
          [title]="title()">
    <input #content [(ngModel)]="setting().value" hisNumber type="number" class="inputWidth100"
           [min]="+setting().minValue || undefined"
           [max]="+setting().maxValue || undefined"
           [readonly]="setting().readonly">
</his-plam>
